var map = {
	"./1/symbol_0.png": 77994,
	"./1/symbol_1.png": 33203,
	"./1/symbol_2.png": 58712,
	"./1/symbol_3.png": 26977,
	"./1/symbol_4.png": 90862,
	"./1/symbol_5.png": 33879,
	"./1/symbol_6.png": 49596,
	"./1/symbol_7.png": 62661,
	"./1/symbol_8.png": 32066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62810;